import React from "react";
import { Campaign } from "../../services";

interface CampaignTimeDisplayProps {
  campaign: Campaign;
}

const CampaignTimeDisplay: React.FC<CampaignTimeDisplayProps> = ({
  campaign,
}) => {
  // Xác định trạng thái chiến dịch
  const now = new Date();
  const startDate = new Date(campaign.start_date);
  const endDate = new Date(campaign.end_date);

  // So sánh chỉ theo ngày, không theo giờ
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDay = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );
  const endDay = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );

  const isNotStarted = startDay > today;
  const isExpired = endDay < today;
  // const isActive = !isNotStarted && !isExpired; // Bỏ comment nếu cần dùng
  // const isOutOfCodes = (campaign.usedCodes || 0) >= (campaign.totalCodes || 0); // Bỏ comment nếu cần dùng

  if (isNotStarted) {
    return (
      <div>
        <div
          className="text-sm text-orange-600 font-medium truncate"
          title="Chưa bắt đầu"
        >
          Chưa bắt đầu
        </div>
        <div
          className="text-xs text-gray-500 mt-1 truncate"
          title={`Bắt đầu: ${startDate.toLocaleDateString("vi-VN")}`}
        >
          Bắt đầu: {startDate.toLocaleDateString("vi-VN")}
        </div>
      </div>
    );
  } else if (isExpired) {
    return (
      <div>
        <div
          className="text-red-600 font-medium text-xs lg:text-sm truncate"
          title="Chiến dịch đã kết thúc"
        >
          Chiến dịch đã kết thúc
        </div>
        <div
          className="text-xs text-gray-500 mt-1 truncate"
          title={`Kết thúc: ${endDate.toLocaleDateString("vi-VN")}`}
        >
          Kết thúc: {endDate.toLocaleDateString("vi-VN")}
        </div>
      </div>
    );
  } else {
    // Chiến dịch đang diễn ra
    const timeDiff = endDay.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

    // Kiểm tra xem chiến dịch có hết mã không
    const isOutOfCodes = false; // TODO: Add usedCodes field to API response

    // Nếu daysLeft < 0, chiến dịch đã kết thúc
    if (daysLeft < 0) {
      return (
        <div>
          <div
            className="text-red-600 font-medium text-xs lg:text-sm truncate"
            title="Chiến dịch đã kết thúc"
          >
            Chiến dịch đã kết thúc
          </div>
          <div
            className="text-xs text-gray-500 mt-1 truncate"
            title={`Kết thúc: ${endDate.toLocaleDateString("vi-VN")}`}
          >
            Kết thúc: {endDate.toLocaleDateString("vi-VN")}
          </div>
        </div>
      );
    }

    return (
      <div>
        <div
          className={`font-medium text-xs lg:text-sm truncate ${
            isOutOfCodes ? "text-blue-600" : "text-green-600"
          }`}
          title={`Còn ${daysLeft} ngày`}
        >
          Còn {daysLeft} ngày
        </div>
        <div
          className="text-xs text-gray-500 mt-1 truncate"
          title={`Kết thúc: ${endDate.toLocaleDateString("vi-VN")}`}
        >
          Kết thúc: {endDate.toLocaleDateString("vi-VN")}
        </div>
      </div>
    );
  }
};

export default CampaignTimeDisplay;
